// extracted by mini-css-extract-plugin
export default {"container":"RootLayout_container__eSX95","main":"RootLayout_main__kdERi"};